import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IFetchTermbaseEntriesPayload,
  ICreateTermbasePayload,
  IUpdateTermbasePayload,
  IDeleteTermbasePayload,
  IUpdateTermbaseEntryPayload,
  IAddTermbaseEntryPayload,
  IDeleteTermbaseEntryPayload,
  IFetchTermbasesPayload,
  IImportTermbaseEntriesPayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function fetchTermbases(payload: IFetchTermbasesPayload) {
  return axios.get(`/api/v1/termbases/`, { params: convertToSnakeCase(payload) })
}

export function fetchTermbaseEntries(payload: IFetchTermbaseEntriesPayload) {
  return axios.get('/api/v1/termbase_entries', { params: convertToSnakeCase(payload) })
}

export function createTermbase(payload: ICreateTermbasePayload) {
  return axios.post(`/api/v1/termbases/`, convertToSnakeCase(payload), config)
}

export function updateTermbase(payload: IUpdateTermbasePayload) {
  return axios.put(`/api/v1/termbases/${payload.id}`, convertToSnakeCase(payload), config)
}

export function deleteTermbase(payload: IDeleteTermbasePayload) {
  return axios.delete(`/api/v1/termbases/${payload.id}`, config)
}

export function updateTermbaseEntry(payload: IUpdateTermbaseEntryPayload) {
  return axios.put(`/api/v1/termbase_entries/${payload.termbaseEntryId}`, convertToSnakeCase(payload), config)
}

export function addTermbaseEntry(payload: IAddTermbaseEntryPayload) {
  return axios.put(`/api/v1/termbases/${payload.id}/add_entry`, config)
}

export function deleteTermbaseEntry(payload: IDeleteTermbaseEntryPayload) {
  return axios.delete(`/api/v1/termbase_entries/${payload.id}`, config)
}

export function importTermbaseEntries(payload: IImportTermbaseEntriesPayload) {
  return axios.put(`/api/v1/termbases/${payload.termbaseId}/import_entries`, convertToSnakeCase(payload), config)
}
